import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  body, html, #root {
    font-family: 'Inter', Arial, Helvetica, sans-serif;
  }
`
